
export const getFinancialYearStartDate = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1; // getMonth() is zero-based
    let startYear = currentMonth >= 4 ? currentYear : currentYear - 1;
    const startDate = new Date(`${startYear}-04-01`);
    return startDate.toISOString().split('T')[0];  // Convert to YYYY-MM-DD format
};